export default {
    "name": "AutofillByZip",
    "kind": "HoudiniQuery",
    "hash": "2670d72eff0ce6d7c5a2f2bb9e2fdb1212fc76603760aef7be5cebee7f6efbe1",

    "raw": `query AutofillByZip($zipcode: String!) {
  autofillByZip(zipcode: $zipcode) {
    city
    country
    stateAbbreviation
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "autofillByZip": {
                "type": "ZipcodeOutput",
                "keyRaw": "autofillByZip(zipcode: $zipcode)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "city": {
                            "type": "String",
                            "keyRaw": "city",
                            "nullable": true,
                            "visible": true
                        },

                        "country": {
                            "type": "String",
                            "keyRaw": "country",
                            "nullable": true,
                            "visible": true
                        },

                        "stateAbbreviation": {
                            "type": "String",
                            "keyRaw": "stateAbbreviation",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "zipcode": "String"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=0cd16bb686e2eaef16d96dd36f21da05dbb540802d8c87d1e0b9d104e71c4d3f";